// removed by extract-text-webpack-plugin
module.exports = {"userEligiblePrompt":"userEligiblePrompt__2CUw7","closeButton":"closeButton__Gu_IF"};


//////////////////
// WEBPACK FOOTER
// ./components/buyWithInstacredLanding/eligiblePrompt/style.css
// module id = JWyT
// module chunks = 323